<script setup>
import { computed, useSlots } from "vue";

defineEmits(["submitted"]);

const hasActions = computed(() => !!useSlots().actions);
</script>

<template>
    <div class="max-w-7xl grid grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 lg:px-8 md:grid-cols-3 sm:px-6">
        <div>
            <h2 class="text-base font-semibold leading-7 text-gray-900 dark:text-white">
                <slot name="title" />
            </h2>
            <p class="mt-1 text-sm leading-6 text-gray-600 dark:text-gray-400">
                <slot name="description" />
            </p>
        </div>

        <form class="md:col-span-2" @submit.prevent="$emit('submitted')">
            <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                <slot name="form" />
            </div>

            <div v-if="hasActions" class="flex items-center mt-8">
                <slot name="actions" />
            </div>
        </form>
    </div>
</template>
